const colors = require("tailwindcss/colors");

const COLORS = {
  black: {
    DEFAULT: "#282828",
    50: "#28282880",
  },
  white: "#fdfdfd",
  sephia: "#FBF8F5",
  transparent: colors.transparent,
  inherit: colors.inherit,
  gray: {
    25: "#f5f5f5",
    50: "#f0f0f0",
    100: "#dad9d5",
    300: "#a09f9c",
    400: "#8e8d8b",
    500: "#696867",
    700: "#4a4948",
  },
  green: {
    25: "#f7f8f7",
    50: "#e9ece9",
    200: "#d5e0d7",
    300: "#BAC8BC",
    400: "#A2B2A4",
    500: "#778e84",
    600: "#47645a",
    800: "#354b43",
    900: "#293833",
  },
  peach: {
    25: "#fbf3ea",
    50: "#fbeddf",
    100: "#fce3ca",
    400: "#f8d1ad",
    600: "#f2b27c",
    700: "#f2b27c",
    900: "#e0995d",
  },
  red: {
    25: "#f6eae8",
    50: "#fcebf0",
    100: "#e7bab6",
    300: "#e392a4",
    500: "#d04968",
    550: "#B82D14",
    600: "#92253e",
    800: "#721d31",
  },
  orange: {
    brown: "#ad492e",
    brand: "#ff9e17",
    200: "#ffe0b8",
    400: "#ffc170",
    600: "#ff9e17",
    700: "#d37126",
    900: "#d37126",
  },
  blue: {
    100: "#E1E9F1",
    700: "#00407A",
  },
  status: {
    success: {
      DEFAULT: "#337227",
      50: "#f6fcf5",
      200: "#BBD3B7",
      400: "#85d076",
      600: "#337227",
      800: "#306a24",
    },
    error: {
      DEFAULT: "#b82d14",
      50: "#fdf6f5",
      100: "#EBDBD7",
      300: "#f38781",
      400: "#ef5f57",
      600: "#b31910",
      800: "#83120c",
    },
    warning: "#ff9f14",
  },
  campaign: { DEFAULT: "#eb0000", dark: "#B82D14" },
};

const STATIC_COLORS = {
  BRAND: COLORS.orange["600"],
  GREEN: COLORS.green["600"],
  GREEN_DARKER: COLORS.green["800"],
  GREEN_BACKGROUND: COLORS.green["50"],
  GREEN_BACKGROUND_DARKER: COLORS.green["200"],
  RED: COLORS.red["600"],
  RED_DARKER: COLORS.red["800"],
  RED_BACKGROUND: COLORS.red["50"],
  RED_BACKGROUND_DARKER: COLORS.red["300"],
  ORANGE: COLORS.orange["700"],
  ORANGE_DARKER: COLORS.orange.brown,
  ORANGE_BACKGROUND: COLORS.peach["25"],
  ORANGE_BACKGROUND_DARKER: COLORS.peach["400"],
  GRAY: COLORS.gray["300"],
  GRAY_LIGHTEST: COLORS.gray["50"],
  GRAY_LIGHTER: COLORS.gray["100"],
  GRAY_DARKER: COLORS.gray["500"],
  BLUE: COLORS.blue["100"],
  BLUE_DARKER: COLORS.blue["700"],
  SEPHIA: COLORS.sephia,
  BLACK: COLORS.black["DEFAULT"],
  WHITE: COLORS.white,
  SUCCESS: COLORS.status.success["DEFAULT"],
  WARNING: COLORS.status.warning,
  ERROR: COLORS.status.error["DEFAULT"],
  CAMPAIGN: COLORS.campaign["DEFAULT"],
  CAMPAIGN_DARK: COLORS.campaign["dark"],
};

const COLOR_ALIASES = {
  link: COLORS.black["DEFAULT"],
  text: COLORS.black["DEFAULT"],
};

const COLOR_EXTENSIONS = {
  orange: {
    DEFAULT: COLORS.orange["700"],
    background: STATIC_COLORS.ORANGE_BACKGROUND,
    backgroundDarker: STATIC_COLORS.ORANGE_BACKGROUND_DARKER,
  },
  red: {
    DEFAULT: COLORS.red["600"],
    background: STATIC_COLORS.RED_BACKGROUND,
    backgroundDarker: STATIC_COLORS.RED_BACKGROUND_DARKER,
  },
  green: {
    DEFAULT: COLORS.green["600"],
    background: STATIC_COLORS.GREEN_BACKGROUND,
    backgroundDarker: STATIC_COLORS.GREEN_BACKGROUND_DARKER,
  },
  gray: {
    DEFAULT: STATIC_COLORS.GRAY,
  },
  ag: {
    brand: "#008993",
  },
};

module.exports = {
  STATIC_COLORS,
  COLOR_ALIASES,
  COLORS,
  COLOR_EXTENSIONS,
};
